// Installs the Segment analytics.js snippet, reading the write key from
// runtime config instead of baking it in at build time. This lets each
// deployment (Vercel prod/preview, or a Docker-built ERE) supply its own
// write key at startup.
function installSegmentSnippet(writeKey) {
  // the console.error('Segment snippet included twice.') has been removed from Segment's script to avoid a misleading console error
  // If updating this script in the future, you will want to test whether or not this should be added back in
  !function() {
    var analytics = window.analytics = window.analytics || []
    if (!analytics.initialize) {
      if (analytics.invoked) {
        window.console && console.error
      } else {
        analytics.invoked = true
        analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on', 'addSourceMiddleware', 'addIntegrationMiddleware', 'setAnonymousId', 'addDestinationMiddleware']
        analytics.factory = function(e) {
          return function() {
            var t = Array.prototype.slice.call(arguments)
            t.unshift(e)
            analytics.push(t)
            return analytics
          }
        }
        for (var e = 0; e < analytics.methods.length; e++) {
          var key = analytics.methods[e]
          analytics[key] = analytics.factory(key)
        }
        analytics.load = function(key, e) {
          var t = document.createElement('script')
          t.type = 'text/javascript'
          t.async = true
          t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
          var n = document.getElementsByTagName('script')[0]
          n.parentNode.insertBefore(t, n)
          analytics._loadOptions = e
        }
        analytics._writeKey = writeKey
        analytics.SNIPPET_VERSION = '4.15.3'
        // Always install the window.analytics stub queue (other plugins and
        // components call it unconditionally), but only load the real
        // Segment script and fire the first page view when a key is
        // configured (e.g. local dev, or an ERE with the var unset).
        if (writeKey) {
          analytics.load(writeKey)
          analytics.page()
        }
      }
    }
  }()
}

export default defineNuxtPlugin((nuxtApp) => {
  installSegmentSnippet(useRuntimeConfig().public.segmentWriteKey)

  const segment = {
    initBaseEvents: (user, permissions) => {
      if (window.analytics) {
        window.analytics.identify(user.id, {
          name: `${user.firstName} ${user.lastName}`,
          email: user.email,
          roles: user.roles,
          states: user.states,
          permissions,
          screenWidth: window.screen.availWidth,
          screenHeight: window.screen.availHeight,
        })

        const agency = user.agency

        window.analytics.group(agency.id, {
          shortID: agency.shortID,
          name: agency.name,
          email: agency.notificationEmail,
          phone: agency.phone,
          streetLine1: agency.streetLine1,
          streetLine2: agency.streetLine2,
          city: agency.city,
          state: agency.state,
          zip: agency.zip,
          appointedStates: agency.appointedStates,
        })
      }
    },
    sendPageEvent: () => {
      const fullPath = nuxtApp.$router.currentRoute.value.fullPath

      // this grabs the current routes search, window.location.search grabs previous search state
      const searchVal = fullPath.split('?')[1]

      // title currently populates with previous routes data, for now we can leave as an empty string
      window.analytics.page({
        path: nuxtApp.$router.currentRoute.value.path,
        // TODO: Verify that this history state check is valid to replace the from path.
        // referrer: `${window.location.origin}${nuxtApp.ctx.from.fullPath}`,
        referrer: `${window.location.origin}${nuxtApp.$router.options.history.state.back}`,
        search: searchVal ? `?${searchVal}` : '',
        title: '',
        url: `${window.location.origin}${fullPath}`,
      })
    },
    trackEvent: (eventName, properties) => {
      if (window.analytics) {
        window.analytics.track(eventName, properties)
      }
    },
  }

  return {
    provide: {
      segment,
    },
  }
})
